import React, {Component} from 'react';
import BaseComponent from "../../../base/BaseComponent";
import {Tabs, Button, Input, Icon, Pagination, Popconfirm, Modal, Tree} from "antd";
import {message} from "../../../view/sysManagement/utils/sysManagementUtils";
import GroupPhoto from "./GroupPhoto";
import {uuid} from "../../../utils";
import {Scrollbars} from "react-custom-scrollbars";
import BaseTable from "../../../view/components/baseTable/BaseTable";
import {HEADER_HEIGHT} from "../../../constants";
import moment from 'moment';
import Video from "./Video";
import Audio from "./Audio";
import ArticleSortModal from "./articleDragSort/ArticleSortModal";
import RmtPopconfirm from "../../../view/components/rmtPopconfirm/rmtPopconfirm";
import ArticleSvg from "./articleSvg/articleSvg";
import {getColorByState} from "../../../view/components/colorByState/colorByState";

const {Search} = Input;
const {TabPane} = Tabs;
const {TreeNode} = Tree;
const CONTENT_PADDING = 30;
const doStoryState = {
    undo: '/cm-sites-mmp/mf/status', // 撤稿
    change: '/cm-sites-mmp/mf/change', // 置顶/取消置顶  推荐/取消推荐
};

class ArticleList extends BaseComponent {

    constructor(props) {
        super(props);
        this.tabs = [
            {tab: "全部", key: "_1"},
            {tab: "我的稿件", key: "_2", params: {submitter: true}},
            {tab: "草稿", key: "_3", params: {status: "草稿"}},
            {tab: "已发布", key: "_4", params: {status: "已发布"}},
            {tab: "已撤稿", key: "_5", params: {status: "已撤稿"}},
        ];
        this.mediaId = this.props.match.params.mediaId ? this.props.match.params.mediaId : '';
        this.columnId = this.props.match.params.columnId ? this.props.match.params.columnId : '';
        this.state = {
            start: 1,
            size: 10,
            total: 0,
            dataSource: [],
            disable: 0,
            mediaName: "",
            rmType: 0,
            params: {},
            rmId: 0,
            treeNodeWithdrawVisible: false,
            treeWithdrawData: [],
            tableIsLoading: false,
            columnType: null
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.mediaId = nextProps.match.params.mediaId ? nextProps.match.params.mediaId : '';
        this.columnId = nextProps.match.params.columnId ? nextProps.match.params.columnId : '';
        this.setState({
            initOver: false,
            start: 1,
            size: 10,
            tableIsLoading: true
        }, () => {
            this.getColumnInfo();
            this.getDataSource();
            this.getMediaById();
        });
    }

    componentWillMount() {
        // 监听 RmAppEditor 页面发送的消息
        this.createPostMessage((e) => {
            let message = e['data'] && typeof e['data'] == 'string' ? JSON.parse(e['data'])['message'] : null;
            if (message == "请求刷新父页面") {
                this.getDataSource();
            }
        }, "rmArticleList")
    }

    componentDidMount() {
        this.getColumnInfo();
        this.getDataSource();
        this.getMediaById();
    }

    componentWillUnmount() {
        // 销毁postMessage监听
        this.destroyPostMessage("rmArticleList");
    }

    //获取当前是否为禁用状态
    getMediaById = () => {
        this.request({
            url: "/cm-sites-pms/media/getById",
            body: {
                mediaId: this.mediaId
            },
            callBack: (res) => {
                let disable = 0;
                if (res) {
                    disable = res.disable
                }
                this.setState({disable, mediaName: res.name, rmType: res.rmType});
            }
        })
    };

    getColumnInfo = () => {
        let columnId = this.columnId;
        if (columnId) {
            this.request({
                url: "/cm-sites-mmp/column/findByColumnId",
                method: "post",
                body: {
                    columnId,
                }, callBack: (res) => {
                    let columnName = "";
                    let columnType = null;
                    if (res) {
                        columnName = res.columnName;
                        columnType = res.type;
                    }
                    this.setState({
                        columnName,
                        columnType,
                        initOver: true
                    })
                }
            });
        }
    };

    getDataSource(title = "", params = {}) {
        this.request({
            url: "/cm-sites-mmp/mf/pageList",
            body: {
                start: this.state.start,
                size: this.state.size,
                columnId: this.columnId,
                title,
                mediaId: this.mediaId,
                ...params
            },
            callBack: (res) => {
                let dataSource = [];
                let total = 0;
                if(res && res.data && res.data.length) {
                    dataSource = res.data;
                    total = res.count;
                    dataSource.forEach(item => {
                        item.key = item.id;
                    })
                }
                this.setState({dataSource, total, tableIsLoading: false});
            },
            errorCallBack: (e) => {
            },
        })
    }

    getInitInfo = () => {
        return {
            mediaId: this.mediaId,
            columnId: this.columnId,
            columnName: this.state.columnName,
            top: 0,
            recommend: 0,
            mediaName: this.state.mediaName,
            rmType: this.state.rmType
        };
    };

    //视频初始信息
     getVideoInitInfo = async () => {
        let mediaId = this.sysConfigGetValueByKey("rmApp.video.initInfo.mediaId", "")
        let videoInitInfo;
        // 如果配置项的值为空对象或不存在，设置初始值
        if (mediaId) {
            try {
                const res = await this.getMediaByIdAsync(mediaId);
                videoInitInfo = {
                    mediaId: res ? res.id : this.mediaId,
                    mediaName: res ? res.name : this.state.mediaName,
                    rmType: res ? res.rmType : this.state.rmType
                };
            } catch (error) {
                console.error("Error retrieving media information:", error);
                videoInitInfo = {
                    mediaId: this.mediaId,
                    mediaName: this.state.mediaName,
                    rmType: this.state.rmType
                };
            }
        }else {
            const res = await this.getMediaInitInfo();
            videoInitInfo = {
                mediaId: res ? res.id : this.mediaId,
                mediaName: res ? res.name : this.state.mediaName,
                rmType: res ? res.rmType : this.state.rmType
            };
        }
        return {
            mediaId: videoInitInfo.mediaId,
            columnId: this.columnId,
            columnName: this.state.columnName,
            top: 0,
            recommend: 0,
            mediaName: videoInitInfo.mediaName,
            rmType: videoInitInfo.rmType
        };
    };
    mediaInfoCache = new Map(); // 使用Map作为缓存
    getMediaByIdAsync = (mediaId) => {
        return new Promise((resolve, reject) => {
            if (this.mediaInfoCache.has(mediaId)) {
                // 如果缓存中存在结果，直接返回缓存的值
                resolve(this.mediaInfoCache.get(mediaId));
            } else {
                const callback = (res) => {
                    // 将结果缓存起来
                    this.mediaInfoCache.set(mediaId, res);
                    resolve(res);
                };
                this.getVideoMediaInfoById(mediaId, callback);
            }
        });
    };

    getMediaInitInfo = () => {
        return new Promise((resolve, reject) => {
            this.getVideoMediaInfoById(this.mediaId, resolve);
        });
    };

    getVideoMediaInfoById(mediaId, callBack) {
        this.request({
            url: "/cm-sites-pms/media/getById",
            body: {
                mediaId
            },
            callBack: (res) => {
                callBack(res);
            }
        })
    }

    openArticle(record) {
        if (record) {
            window.openEditById({
                configName: "rmAppEditor",
                id: record.id,
                params: {
                    activitiConfName: "activitiTreeRoot-rmapp",
                    mediaId: record.mediaId,
                    columnId: record.columnId,
                    columnName: record.columnName,
                    mediaFusion: record
                }
            });
            return;
        }
        window.openEditById({
            configName: "rmAppEditor",
            id: "0",
            params: {
                activitiConfName: "activitiTreeRoot-rmapp",
                mediaId: this.mediaId,
                columnId: this.state.columnId,
                columnName: this.state.columnName,
                mediaFusion: this.getInitInfo()
            }
        });
    }

    groupPhotoDialogKey = uuid();

    render() {
        return this.state.initOver ? <div className={"rm-app-article"} style={{
            margin: '15px',
            // height: 'calc(100vh - 100px)',
            borderRadius: '5px',
            overflow: 'hidden',
            background: 'rgb(255, 255, 255)'
        }}>
            {this.renderTabs()}
            {this.renderBtns()}
            {this.renderTable()}
            {this.renderPage()}
            {this.renderWithdrawModal()}
        </div> : <></>
    }

    renderTable() {
        let {dataSource} = this.state;
        let rowSelection = {
            onSelectAll: (selected, selectedRows, changeRows) => {
                let {checkedData} = this.state;
                let newCheckedData = [...checkedData];
                if (selected) { // 全选中
                    for (let i = 0; selectedRows && i < selectedRows.length; i++) {
                        let row = selectedRows[i];
                        let isAdd = true;
                        for (let j = 0; checkedData && j < checkedData.length; j++) {
                            let data = checkedData[j];
                            if (row.id === data.id) {
                                isAdd = false
                            }
                        }
                        if (isAdd) {
                            newCheckedData.push(row);
                        }
                    }
                } else { // 全部不选中
                    newCheckedData = [];
                    for (let j = 0; checkedData && j < checkedData.length; j++) {
                        let data = checkedData[j];
                        let isRemove = false;
                        for (let i = 0; changeRows && i < changeRows.length; i++) {
                            let row = changeRows[i];
                            if (row.id === data.id) {
                                isRemove = true;
                            }
                        }
                        if (!isRemove) {
                            newCheckedData.push(data);
                        }
                    }
                }
                this.setState({checkedData: newCheckedData});
            },
            onSelect: (record, selected) => {
                let {checkedData} = this.state;
                let newCheckedData = [...checkedData];
                if (selected) {
                    newCheckedData.push(record);
                } else {
                    newCheckedData = newCheckedData.filter(item => item.id !== record.id);
                }
                this.setState({checkedData: newCheckedData});
            }
        };
        let columns = [
            {
                title: '名称',
                dataIndex: "title",
                key: "title",
                ellipsis: true,
                width: 400,
                render: (text, record) => {
                    return <span onClick={() => {
                        this.onClickUpdate(record)
                    }} style={{cursor: "pointer"}}>{text}</span>
                }
            }, {
                title: '类型',
                dataIndex: "type",
                key: "type",
                width: 70,
                render: (text, record) => {
                    return <span>{(() => {
                        switch (text) {
                            case 1:
                                return "图集";
                            case 2:
                                return "视频";
                            case 3:
                                return "音频";
                        }
                        return "文章";
                    })()}</span>
                }
            }, {
                title: '创建时间',
                dataIndex: "createTime",
                key: "createTime",
                width: 170,
                render: (text) => {
                    return moment(parseInt(text)).format("YYYY-MM-DD HH:mm:ss")
                }
            }, {
                title: '状态',
                dataIndex: "statusName",
                key: "statusName",
                width: 120,
                ellipsis: true,
                render: (text) => {
                    let color = getColorByState(text);
                    return (
                        <div className={'dotState'}>
                            <div style={{background: color, marginTop: 2}}></div>
                            {text}
                        </div>
                    )
                }
            }, {
                title: '热度',
                dataIndex: "rd",
                key: "rd",
                width: 260,
                render: (text, record) => {
                    return <div style={{display: "flex", alignItems: "center", color: "rgba(0, 0, 0, 0.65)"}}>
                        <div style={{marginRight: 5}}><ArticleSvg type={'view'} style={{size: 17}}/> {record.viewNum}</div>
                        <div style={{marginRight: 5}}><ArticleSvg type={'like'} style={{size: 17}}/> {record.likeNum}</div>
                        <div style={{marginRight: 5}}><ArticleSvg type={'share'} style={{size: 17}}/> {record.forwordNum}</div>
                        <div><ArticleSvg type={'collect'} style={{size: 17}}/> {record.collectionNum}</div>
                    </div>
                }
            }, {
                title: '操作',
                dataIndex: "op",
                key: "op",
                align: "left",
                render: (text, record, index) => {
                    return <div style={{textAlign: "left"}}>
                        {
                            this.renderRmtPopConfirm({
                                key: index + "top",
                                text: "top",
                                record,
                                index,
                                urlKey: 'change', // url
                                stateKey: 'top', // 数据里面对应的状态key
                                titleVal: '置顶', // 数据里面对应的状态key
                                visible: 'topStatus', // 弹窗显示隐藏标志
                                doText: "置顶",
                                unDoText: "取消置顶",
                            })
                        }
                        {
                            this.renderRmtPopConfirm({
                                key: index + "recommend",
                                text: "recommend",
                                record,
                                index,
                                urlKey: 'change', // url
                                stateKey: 'recommend', // 数据里面对应的状态key
                                titleVal: '推荐', // 数据里面对应的状态key
                                visible: 'recommendStatus', // 弹窗显示隐藏标志
                                doText: "推荐",
                                unDoText: "取消推荐",
                            })
                        }
                        <Button type={"link"} style={{padding: "0 5px"}} onClick={() => {
                            this.onClickUpdate(record)
                        }}>修改</Button>
                        {record.statusName === "已发布" && <Popconfirm placement="topLeft" title={"您确定要撤稿吗？"}
                                                                    onConfirm={() => this.changeStatus(record.id, "已撤稿")}
                                                                    okText="是" cancelText="否">
                            <Button type={"link"} style={{padding: "0 5px"}}>撤稿</Button>
                        </Popconfirm>}
                        {record.statusName === "已撤稿" || record.statusName === "草稿" ?
                            <Popconfirm placement="topLeft" title={"您确定要删除吗？"}
                                        onConfirm={() => this.delete(record.id)} okText="是" cancelText="否">
                                <Button type={"link"} style={{padding: "0 5px"}}>删除</Button>
                            </Popconfirm> : null}
                    </div>
                }
            }
        ];
        return <div style={{margin: `0 ${CONTENT_PADDING}px`}}>
            <Scrollbars autoHeight autoHeightMax={document.body.clientHeight - HEADER_HEIGHT - 260}>
                <BaseTable loading={this.state.tableIsLoading} rowSelection1={rowSelection} columns={columns} dataSource={dataSource}/>
            </Scrollbars></div>
    }

    onClickUpdate(record) {
        if (record.type === 0) {
            this.openArticle(record);
        } else if (record.type === 1) {
            this.groupPhoto.showEditModal(record);
        } else if (record.type === 2) {
            this.mmpVideoModal.show(record)
        } else if (record.type === 3) {
            this.mmpAudioModal.show(record)
        }
    }

    testArrError(arr) {
        if (!(arr instanceof Array)) {
            arr = undefined;
        }
        return arr !== undefined && arr !== null && arr.length >= 0 ? [...arr] : [];
    }

    renderRmtPopConfirm = ({key, text, record, index, urlKey, stateKey, titleVal, visible, doText, unDoText}) => {
        // 0 未置顶 1 置顶
        let isTop = text === "top" ? record.top : record.recommend;
        let hasMore = record.deliveryMediaFusionList && record.deliveryMediaFusionList.length > 0; // 是否多栏目
        let allColumn = [{
            columnId: record.columnId,
            mediaId: record.mediaId,
            columnName: record.columnName,
            mediaName: record.mediaName,
            [stateKey]: record[stateKey],
        }, ...this.testArrError(record.deliveryMediaFusionList)]; // 所有栏目集合
        // 如果不是主栏目则需要另外判断
        if (hasMore && (record.columnId !== this.columnId)) {
            // 寻找子栏目置顶状态
            let sonRecord = record.deliveryMediaFusionList.find(item => item.columnId === this.columnId) || {};
            isTop = sonRecord[stateKey]
        }
        let similar = allColumn.filter(column => column[stateKey] === isTop); // 与当前栏目相同状态的栏目集合
        let havMore = similar.length > 1; // 是否存在与当前栏目状态相同的其他栏目
        let title = havMore ? `该文章同时发布到多个栏目，请问其他栏目需要同步设置${titleVal}吗？` : `确定要设置${titleVal}吗？`;
        let allBtnName = havMore ? `全部${titleVal}` : `${titleVal}`;
        let renderWithdrawModalTitle = `选择需要设置${titleVal}的栏目`;
        if (isTop) {
            renderWithdrawModalTitle = `选择需要取消设置${titleVal}的栏目`;
            title = havMore ? `该文章同步设置${titleVal}到多个栏目，请问需要取消其他栏目${titleVal}吗？` : `确定要取消设置${titleVal}吗`;
            allBtnName = havMore ? `全部取消` : `取消${titleVal}`;
        }
        return (
            <RmtPopconfirm
                key={(record.id + key)}
                visible={record[visible]}
                title={<div style={{marginLeft: 10}}>{title}</div>}
                icon={<Icon type={'question-circle'}
                            style={{color: '#faad14', fontSize: 22}}/>}
                footer={
                    <div style={{display: 'flex', justifyContent: 'flex-end',}}>
                        <Button onClick={() => {
                            this.state.dataSource[index][visible] = false;
                            this.setState({})
                        }}>取消</Button>
                        {
                            havMore ?
                                <Button onClick={() => {
                                    this.state.treeWithdrawData = [];
                                    this.setTreeWithdrawData(similar, {
                                        key: stateKey,
                                        val: isTop,
                                    });
                                    this.state.record = record;
                                    this.state.currentClickType = text;
                                    this.state.isTop = isTop;
                                    this.state.dataSource[index][visible] = false;
                                    this.state.checkedWithdrawKeys = [];
                                    this.setState({
                                        renderWithdrawModalTitle: renderWithdrawModalTitle,
                                        treeNodeWithdrawVisible: true,
                                    })
                                }}>选择栏目</Button>
                                : null
                        }
                        {
                            havMore ?
                                <Button onClick={() => {
                                    let columnId = this.columnId;
                                    this.state.record = record;
                                    this.state.currentClickType = text;
                                    this.state.isTop = isTop;
                                    this.state.dataSource[index][visible] = false;
                                    this.setState({});
                                    this.state.checkedWithdrawKeys = [columnId];
                                    this.onStoryStateOk("currentColumn");
                                }}>当前栏目</Button>
                                : null
                        }
                        <Button onClick={() => {
                            this.state.dataSource[index][visible] = false;
                            this.state.record = record;
                            this.state.currentClickType = text;
                            this.state.isTop = isTop;
                            this.state.checkedWithdrawKeys = similar.map(item => item.columnId);
                            this.onStoryStateOk()
                        }} type={'primary'}>{allBtnName}</Button>
                    </div>
                }
            >
                <Button key={record.id} type={"link"} style={{padding: "0px 5px 0px 0px"}} onClick={() => {
                    if(this.state.disable == 1){
                        return false
                    }else {
                        this.state.rmId = record.id;
                        this.state.record = record;
                        this.state.currentClickType = text;
                        this.state.urlKey = urlKey;
                        this.state.isTop = isTop;
                        if(havMore) {
                            this.state.dataSource[index][visible] = true;
                            this.setState({});
                        } else {
                            this.state.checkedWithdrawKeys = similar.map(item => item.columnId);
                            this.onStoryStateOk("currentColumn")
                        }
                    }
                }}>
                    {(isTop && isTop !== "0") ? unDoText : doText}
                </Button>
            </RmtPopconfirm>
        )
    };

    setTreeWithdrawData = (deliveryNews, config = {}) => {
        deliveryNews.forEach(item => {
            let index = this.state.treeWithdrawData.findIndex(item2 => item2.id == item.mediaId);
            if (item[config.key] == config.val) {
                if (index < 0) {
                    this.state.treeWithdrawData.push({
                        id: item.mediaId,
                        name: item.mediaName,
                        child: [
                            {
                                id: item.columnId,
                                name: item.columnName,
                            }
                        ]
                    })
                } else {
                    let index2 = this.state.treeWithdrawData[index].child.findIndex(item3 => item3.id == item.columnId);
                    if (index2 < 0) {
                        this.state.treeWithdrawData[index].child.push({
                            id: item.columnId,
                            name: item.columnName,
                        })
                    }
                }
            }
        });
    };

    getOperateResult(record, columnId) {
        let hasMore = record.deliveryMediaFusionList && record.deliveryMediaFusionList.length > 0; // 是否多栏目
        let isHaveTitlePic = ((record.titlePicList && !record.titlePicList.length) || !record.titlePicList);
        let isTop = record.top;
        let isRecommend = record.recommend;
        if (hasMore && (record.columnId !== columnId)) {
            let findItem = record.deliveryMediaFusionList.find(item => item.columnId === columnId) || {};
            isHaveTitlePic = ((findItem.titlePicList && !findItem.titlePicList.length) || !findItem.titlePicList);
            isTop = findItem.top;
            isRecommend = findItem.recommend;
        }
        return {isHaveTitlePic, isTop, isRecommend};
    }

    isPass(columnIds, type, currentClickType) {
        if (currentClickType === "recommend") {
            let text = "存在文章无封面图，请检查后再加入推荐！";
            let text2 = "存在文章已置顶，请检查后再加入推荐！"
            for (let i = 0; i < columnIds.length; i++) {
                let item = columnIds[i];
                let {isHaveTitlePic, isTop} = this.getOperateResult(this.state.record, item);
                if (isHaveTitlePic && this.state.record.type === 0) {
                    if (type) text = "该文章无封面图，无法加入推荐！";
                    message.warn(text);
                    return false;
                }
                if (isTop) {
                    if (type) text2 = "该文章已置顶，无法加入推荐！";
                    message.warn(text2);
                    return false;
                }
            }
        }
        if (currentClickType === "top") {
            let text = "存在文章已推荐，请检查后再置顶！"
            for (let i = 0; i < columnIds.length; i++) {
                let item = columnIds[i];
                let {isRecommend} = this.getOperateResult(this.state.record, item);
                if (isRecommend) {
                    if (type) text = "该文章已推荐，无法置顶！";
                    message.warn(text);
                    return false;
                }
            }
        }
        return true;
    }

    onStoryStateOk = (type) => {
        if (this.state.checkedWithdrawKeys && this.state.checkedWithdrawKeys.length) {
            let columnIds = this.state.checkedWithdrawKeys;
            let isJudge = this.state.isTop && this.state.isTop !== "0";  //取消操作不做校验
            if(!isJudge && !this.isPass(columnIds, type, this.state.currentClickType)) return false;
            this.state.treeNodeWithdrawVisible = false;
            this.state.checkedWithdrawKeys = [];
            this.doStoryState(columnIds, this.state.urlKey)
        }
    };

    //稿件状态操作
    doStoryState = (columnIds, urlKey) => {
        let url = doStoryState[urlKey];
        if (!url) return false;
        let operateType = (this.state.isTop === 0 || this.state.isTop === "0") ? 1 : 0;
        let operateName = "top";
        if(this.state.currentClickType === "recommend") {
            operateType = (this.state.isTop === 0 || this.state.isTop === "0") ? 1 : 0;
            operateName = "recommend";
        }
        let body = {columns: columnIds, mediaFusionId: this.state.rmId, operateType, operateName};
        this.request({
            url,
            method: 'post',
            contentType: "json",
            body,
            callBack: (res) => {
                if(res){
                    message.success('操作成功');
                }
                this.getDataSource(this.state.searchValue, this.state.params);
            }
        })
    };

    // 稿件状态修改，栏目选择弹窗
    renderWithdrawModal = () => {
        const {treeWithdrawData} = this.state;
        return (
            <Modal
                centered={true}
                title={this.state.renderWithdrawModalTitle}
                visible={this.state.treeNodeWithdrawVisible}
                onOk={() => {
                    this.onStoryStateOk()
                }}
                onCancel={() => {
                    this.setState({treeNodeWithdrawVisible: false, checkedWithdrawKeys: []})
                }}
                width={400}
            >
                <Scrollbars style={{height: 350,}}>
                    {(treeWithdrawData && treeWithdrawData.length) ? <Tree
                        showIcon
                        checkable
                        defaultExpandParent={true}
                        defaultExpandAll={true}
                        selectable={false}
                        autoExpandParent={true}
                        checkedKeys={this.state.checkedWithdrawKeys}
                        onCheck={this.onWithdrawCheck}
                    >
                        {this.renderWithdrawTreeNodes(treeWithdrawData)}
                    </Tree> : null}
                </Scrollbars>
            </Modal>
        )
    };

    getChild(data, call) {
        for (let item of data) {
            this.showColumnKeys.push(item);
            if (item.child) {
                this.getChild(item.child);
            }
        }
        if(call) {
            call(this.showColumnKeys);
        }
    };

    showColumnKeys = [];

    // 稿件状态修改（置顶头条推荐）栏目选择
    onWithdrawCheck = (checkedWithdrawKeys) => {
        this.showColumnKeys = [];
        let newChecked = checkedWithdrawKeys;
        if (checkedWithdrawKeys && checkedWithdrawKeys.length && (checkedWithdrawKeys.indexOf(this.state.record.columnId + '') > -1)) {
            newChecked = [this.state.record.columnId, ...this.state.record.deliveryMediaFusionList.map(item => item.columnId)];
            message.destroy();
            message.warning('选择主节点后会默认选中其他节点');
        }
        //过滤选中主节点时不存在节点的columnId
        this.getChild(this.state.treeWithdrawData, (arr) => {
            newChecked = newChecked.filter(item => {
                return arr.some(i => item === i.id);
            })
        })
        this.setState({checkedWithdrawKeys: newChecked})
    };

    renderWithdrawTreeNodes = (data) =>
        data.map(item => {
            if (item.child) {
                return (
                    <TreeNode disabled={true} title={this.renderWithdrawTitle("folder-open", item)} key={item.id}
                              dataRef={item}>
                        {this.renderWithdrawTreeNodes(item.child)}
                    </TreeNode>
                );
            }
            return <TreeNode key={item.id} title={this.renderWithdrawTitle("file-text", item)}/>;
        });

    renderWithdrawTitle = (type, item) => {
        return (
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: 190,}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <Icon type={type}/>
                    <span style={{
                        width: 160,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    }}
                    >{item.name}</span>
                </div>
            </div>
        )
    };

    onChange = (start, size) => {
        this.setState({start, size}, () => {
            this.getDataSource(this.state.searchValue, this.state.params);
        })
    };

    renderPage() {
        let {total, start, size} = this.state;
        if (!total) return <div style={{height: 81}}/>;
        let onChange = this.onChange;
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                borderTop: '1px solid #eee',
                padding: '24px 32px',
            }}
            >
                <Pagination
                    size="middle"
                    total={total}
                    showTotal={(total) => `共有${total}条数据`}
                    showSizeChanger
                    showQuickJumper
                    current={start}
                    pageSize={size}
                    onChange={(page, pageSize) => {
                        onChange(page, pageSize)
                    }} //页码改变时回调
                    onShowSizeChange={(page, pageSize) => {
                        onChange(1, pageSize)
                    }} //每页条数改变回调
                />
            </div>
        )
    }

    renderBtns() {
        return <div style={{padding: `${CONTENT_PADDING}px`}}>
            <table width={"100%"} cellSpacing={0} cellPadding={0} border={0}>
                <tbody>
                <tr>
                    {this.state.disable === 0 ?
                        <td align={"left"}>
                            {this.state.columnType !== 3 ?
                                <Button type={"primary"} style={{marginRight: 15}}
                                        onClick={() => this.openArticle()}>发文章</Button> : null}
                            {this.state.columnType !== 3 ?
                                <GroupPhoto key={this.groupPhotoDialogKey}
                                            ref={ref => this.groupPhoto = ref}
                                            btnName={'发图集'}
                                            dynamicParams={() => this.getInitInfo()}
                                            btnStyle={{
                                                marginLeft: 0, marginRight: 15,
                                            }}
                                            onCancel={() => {
                                                this.groupPhotoDialogKey = uuid();
                                                this.setState({})
                                            }}
                                            onOkCall={() => {
                                                this.groupPhotoDialogKey = uuid();
                                                this.state.start = 1;
                                                this.getDataSource(this.state.searchValue, this.state.params);
                                            }}/> : null}
                            <Button type={"primary"} style={{marginRight: 15}} onClick={() => {
                                this.mmpVideoModal.showAddDialog();
                            }}>发视频</Button>
                            <div style={{display: "inline-block"}}>{this.renderVideo()}</div>
                            {this.state.columnType !== 3 ?
                                <Button type={"primary"} style={{marginRight: 15}} onClick={() => {
                                    this.mmpAudioModal.showAddDialog();
                                }}>发音频</Button> : null}
                            <div style={{display: "inline-block"}}>{this.renderAudio()}</div>
                            <Button type={"primary"} style={{marginRight: 15}} onClick={() => {
                                this.saveSort()
                            }}>文章排序</Button>
                            {/*<Button style={{marginRight: 15}}>添加至栏目</Button>*/}
                            {/*<Button style={{marginRight: 15}}>下载</Button>*/}
                        </td> : null}
                    <td align={"right"}>
                        <Search
                            placeholder={"请输入关键字"}
                            allowClear={true}
                            style={{width: 272, height: 32, paddingLeft: '24px'}}
                            className={'mediaConnectionPageSearch'}
                            onSearch={title => {
                                this.state.searchValue = title;
                                this.state.start = 1;
                                this.getDataSource(title, this.state.params);
                            }}
                        />
                    </td>
                </tr>
                </tbody>
            </table>
            <ArticleSortModal ref={ref => this.articleSortModal = ref} mediaId={this.mediaId} columnId={this.columnId}
                              refreshList={() => {
                                  this.state.start = 1;
                                  this.getDataSource(this.state.searchValue, this.state.params)
                              }}/>
            <style>{`
                        .rm-app-article .mediaConnectionPageSearch .ant-input {
                            background-color: #f5f8fc;
                        }
                    `}</style>
        </div>;
    }

    saveSort() {
        this.articleSortModal.showModal();
    }

    renderVideo() {
        return <Video key={(() => {
            if (!this.state.mmpVideoModalKey) {
                this.state.mmpVideoModalKey = uuid();
            }
            return this.state.mmpVideoModalKey
        })()}
                      {...{
                          url: {
                              save: '/cm-sites-mmp/mf/save',
                              publish: '/cm-sites-mmp/mf/status/',
                          }
                      }}
                      dynamicParams={() => this.getVideoInitInfo()}
                      onOkCall={() => {
                          this.state.mmpVideoModalKey = uuid();
                          this.state.start = 1;
                          this.getDataSource(this.state.searchValue, this.state.params)
                      }} ref={ref => this.mmpVideoModal = ref}
        />
    }

    renderAudio() {
        return <Audio key={(() => {
            if (!this.state.mmpAudioModalKey) {
                this.state.mmpAudioModalKey = uuid();
            }
            return this.state.mmpAudioModalKey
        })()}
                      {...{
                          url: {
                              save: '/cm-sites-mmp/mf/save',
                              publish: '/cm-sites-mmp/mf/status/',
                          }
                      }}
                      dynamicParams={() => this.getInitInfo()}
                      onOkCall={() => {
                          this.state.mmpAudioModalKey = uuid();
                          this.state.start = 1;
                          this.getDataSource(this.state.searchValue, this.state.params)
                      }} ref={ref => this.mmpAudioModal = ref}
        />
    }

    renderTabs() {
        return <>
            <Tabs size={"small"} onChange={key => {
                let item = this.tabs.find(item => item.key === key);
                this.state.start = 1;
                if (item) {
                    this.state.params = item.params;
                    this.getDataSource(this.state?.searchValue, item.params);
                } else {
                    message.destroy();
                    message.warn("切换失败！")
                }
            }}>
                {this.tabs.map(item => (
                    <TabPane tab={item.tab} key={item.key}/>
                ))}
            </Tabs>
            <style>{`
                    .rm-app-article {
                        padding-top: 12px
                    }
                    .rm-app-article .ant-tabs-nav-scroll{
                        padding: 0 ${CONTENT_PADDING}px;
                    }
                    .rm-app-article div[role="tab"]{
                        line-height: 29px;
                    }
                `}</style>
        </>;
    }

    delete(id) {
        this.request({
            url: "/cm-sites-mmp/mf/delete?id=" + id,
            callBack: () => {
                if (this.state.dataSource.length === 1 && this.state.start > 1) {
                    this.onChange(this.state.start - 1, this.state.size)
                } else {
                    this.onChange(this.state.start, this.state.size)
                }
            }
        })
    }

    changeStatus(id, status) {
        if (!status) {
            message.destroy();
            message.warn("状态为空，操作失败！");
            return;
        }
        this.request({
            url: "/cm-sites-mmp/mf/status/" + id,
            method: "post",
            body: {status},
            callBack: () => {
                this.getDataSource(this.state.searchValue, this.state.params);
            }
        })
    }

    changeTop(id) {
        this.request({
            url: "/cm-sites-mmp/mf/changeTop?id=" + id,
            callBack: () => {
                this.getDataSource(this.state.searchValue, this.state.params);
            }
        })
    }

    changeRecommend(id) {
        this.request({
            url: "/cm-sites-mmp/mf/changeRecommend?id=" + id,
            callBack: () => {
                this.getDataSource(this.state.searchValue, this.state.params);
            }
        })
    }
}

export default ArticleList;
